import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="policy-application"
export default class extends Controller {
  static targets = ['refreshPricesButton', 'nextButton', 'policyApplicationForm', 'updateQuotesAlert', 'useOfferDatesInput', 'policyStartSelect', 'policyEndSelect', 'defaultPolicyStart', 'defaultPolicyEnd'];

  connect() {
    if (this.hasUseOfferDatesInputTarget) {
      this.forceOfferDates();
    }
  }

  forceOfferDates() {
    const shouldForceOfferDates = this._useOfferDates();

    this._setDisabledStateForPolicyDates(shouldForceOfferDates);

    if (shouldForceOfferDates) {
      const defaultStart = new Date(this.defaultPolicyStartTarget.value),
            defaultEnd = new Date(this.defaultPolicyEndTarget.value);

      this._applyDates(this.policyStartSelectTargets, defaultStart);
      this._applyDates(this.policyEndSelectTargets, defaultEnd);
    }
  }

  async reloadPolicyApplication() {
    if (!this.hasRefreshPricesButtonTarget) return;

    this._disableNextButton();

    const form = this.policyApplicationFormTarget;
    const formData = new FormData(form);
    formData.append('refresh_prices', '1');

    const response = await fetch(form.getAttribute('action'), {
      method: (form.getAttribute('method') || 'post').toUpperCase(),
      body: formData,
      headers: {'Accept': 'text/html'}
    });

    if (!response.ok) {
      window.location.reload();
      return;
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const updated = doc.getElementById('policy_application_form');

    if (!updated) {
      window.location.reload();
      return;
    }

    document.getElementById('policy_application_form').innerHTML = updated.innerHTML;
    this._reinitHcaptcha();
  }

  disableNext() {
    if (this.hasRefreshPricesButtonTarget) {
      this._disableNextButton();

      this.updateQuotesAlertTarget.style.display = 'block';
    }
  }

  _disableNextButton() {
    // hcaptcha interferes with the button and creates a div with the same data-target, hence use getElementById
    // this.nextButtonTarget.disabled = true;
    document.getElementById('btn-next').disabled = true;
  }

  _useOfferDates() {
    return this.useOfferDatesInputTarget.checked;
  }

  _setDisabledStateForPolicyDates(state) {
    [...this.policyStartSelectTargets, ...this.policyEndSelectTargets].forEach((select) => {
      select.disabled = state;
    });
  }

  _reinitHcaptcha() {
    if (typeof hcaptcha === 'undefined') return;

    const captchaButton = document.getElementById('btn-next');
    if (!captchaButton?.classList.contains('h-captcha')) return;

    try { hcaptcha.reset(captchaButton); } catch (_e) {}
    hcaptcha.render(captchaButton, {
      sitekey: captchaButton.dataset.sitekey,
      callback: () => {
        document.querySelector('[data-hcaptcha-target="create_or_edit_policy_application"]').submit();
      }
    });
  }

  _applyDates(selectElements, date) {
    selectElements.forEach((select) => {
      const name = select.getAttribute('name');
      if (name.endsWith('(1i)]')) {
        select.value = date.getFullYear();
      } else if (name.endsWith('(2i)]')) {
        select.value = date.getMonth() + 1;
      } else if (name.endsWith('(3i)]')) {
        select.value = date.getDate();
      }
    });
  }
}
